export const STOCK_BASE_PATH = '/stock';

export function stockDetailPath(orderId) {
  return `${STOCK_BASE_PATH}/${encodeURIComponent(String(orderId))}`;
}

/**
 * Parse `/stock` or `/stock/:orderId` from the location pathname.
 * @returns {{ screen: 'list' | 'detail', orderId?: string }}
 */
export function parseStockRoute(pathname) {
  const trimmed = String(pathname || '').replace(/\/+$/, '') || STOCK_BASE_PATH;
  if (trimmed === STOCK_BASE_PATH) {
    return { screen: 'list' };
  }
  if (trimmed.startsWith(`${STOCK_BASE_PATH}/`)) {
    const segment = decodeURIComponent(trimmed.slice(`${STOCK_BASE_PATH}/`.length));
    if (segment) {
      return { screen: 'detail', orderId: segment };
    }
  }
  return { screen: 'list' };
}
